enum SignInRoutes {
  SignIn = '/:country/sign-in',
}

export default SignInRoutes
